import { makeStyles } from "@material-ui/core";

const styleBase = {
  borderRadius: "4px",
  padding: "8px 32px",
  minWidth: 160,
};

const useStyles = makeStyles((theme) => ({
  // Button with green background
  primary: {
    ...styleBase,
    backgroundColor: theme.palette.primary.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.primary.darker,
    },
    "&:disabled": {
      color: "#fff",
      opacity: 0.5,
    },
  },
  // Button with yellow background
  secondary: {
    ...styleBase,
    backgroundColor: theme.palette.secondary.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.secondary.darker,
    },
    "&:disabled": {
      color: "#0F2C2A",
      opacity: 0.5,
    },
  },
  gradient: {
    ...styleBase,
    background: theme.palette.gradient.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: "#DEAB24",
    },
    "&:disabled": {
      color: "#0F2C2A",
      opacity: 0.5,
    },
  },
  dark: {
    ...styleBase,
    background: theme.palette.dark.main,
    color: "#FFF",
    "&:hover": {
      background: theme.palette.dark.secondary,
    },
    "&:disabled": {
      color: "#0F2C2A",
      opacity: 0.5,
    },
  },
  outlinedPrimary: {
    ...styleBase,
    backgroundColor: "transparent",
    color: theme.palette.primary.main,
    border: "1px solid " + theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "#fff",
      color: theme.palette.primary.darker,
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: "#fff",
      opacity: 0.5,
    },
  },
  outlinedSecondary: {
    ...styleBase,
    backgroundColor: "transparent",
    color: theme.palette.secondary.main,
    border: "1px solid " + theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: "#fff",
      color: theme.palette.secondary.darker,
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: "#fff",
      opacity: 0.5,
    },
  },
  outlinedDark: {
    ...styleBase,
    backgroundColor: "transparent",
    color: theme.palette.dark.main,
    border: "1px solid " + theme.palette.dark.main,
    "&:hover": {
      backgroundColor: "#fff",
      color: theme.palette.dark.secondary,
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: "#fff",
      opacity: 0.5,
    },
  },
  // Button with transparency
  transparent: {
    ...styleBase,
    backgroundColor: "transparent",
    color: theme.palette.text.secondary,
    border: "1px solid " + theme.palette.text.secondary,
    "&:hover": {
      backgroundColor: "#fff",
      color: "#0F2C2A",
      borderColor: "#0F2C2A",
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: theme.palette.text.secondary,
      opacity: 0.5,
    },
  },

  // Button sizes
  xs: {
    padding: "3px 24px",
    minWidth: "auto !important",
    "& span": {
      fontSize: 14,
    },
  },
  small: {
    padding: "6px 24px",
    minWidth: "auto !important",
    "& span": {
      fontSize: 14,
    },
  },
  medium: {},
  // Button types
  addAction: {},
  callToAction: {
    borderRadius: "24px",
    minWidth: 250,
  },
  icon: {
    marginRight: "8px",
  },
  mediumLoader: {
    width: "28px !important",
    height: "28px !important",
  },
  smallLoader: {
    width: "24px !important",
    height: "24px !important",
  },
  darkLoader: {
    "& > span > div > svg": {
      color: "#0F2C2A",
      margin: 0,
    },
  },
  lightLoader: {
    "& > span > div > svg": {
      color: theme.palette.text.secondary,
      margin: 0,
    },
  },
}));

export default useStyles;
